<template>
  <div class="col-md-8 col-lg-8 offset-md-2 offset-lg-2 page">
    <div class="form" ref="formContainer">
      <form @submit.prevent="handleSubmit(credential.userName, 'bio')" id="form_bio">
      <h1 class="profile__header mt-md-0 mt-0">PROFILE</h1>
      <!-- todo change password button -->
      <!-- <div class="form-group">
        <label for="profilePassword" class="profile__label">PASSWORD</label>
        <input :disabled=disabled type="password" class="form-control" id="profilePassword">
      </div> -->
      <div class="row">
        <div class="col-md-8 col-lg-8 col-12 form-group">
          <label for="profileFirstName" class="profile__label">FIRST NAME</label>
          <input :disabled=disabled type="text" class="form-control profile_input" id="profileFirstName" name="firstName" :value="patient.firstName">
        </div>
        <div class="col-md-4 col-lg-4 col-12 form-group">
          <label for="profileMiddleName" class="profile__label">MIDDLE NAME</label>
          <input :disabled=disabled type="text" class="form-control profile_input" id="profileMiddleName" name="middleName" :value="patient.middleName">
        </div>
      </div>

      <div class="row">
        <div class="col-md-8 col-lg-8 col-12 form-group">
          <label for="profileLastName" class="profile__label">LAST NAME</label>
          <input :disabled=disabled type="text" class="form-control profile_input" id="profileLastName" name="lastName" :value="patient.lastName">
        </div>
        <div class="col-md-4 col-lg-4 col-12 form-group">
          <label for="profileSuffix" class="profile__label">SUFFIX</label>
          <select :disabled=disabled class="form-select profile_input" id="profileSuffix" name="suffix">
            <option>None</option>
            <option v-for="suffix in suffixes" :key="suffix.id" :selected="patient.suffix === suffix.id">
              {{ suffix.value }}
            </option>
          </select>
        </div>
      </div>

      <div class="row">
        <!-- todo dob format -->
        <div class="col-md-3 col-lg-3 col-sm-6 col-6 form-group">
          <label for="profileDOB" class="profile__label">DATE OF BIRTH</label>
          <input :disabled=disabled type="date" class="form-control profile_input" id="profileDOB" name="dob" :value="credential.dob">
          <small>YYYY-MM-DD</small>
        </div>
        <div class="col-md-3 col-lg-3 col-sm-6 col-6 form-group">
          <label for="profileGender" class="profile__label">GENDER</label>
          <select :disabled=disabled class="form-select profile_input" id="profileGender" name="gender">
            <option v-for="gender in genders"
                    :key="gender.id" :selected="patient.gender[0] === gender.value">
              {{ gender.value }}
            </option>
          </select>
        </div>
        <div class="col-md-3 col-lg-3 col-sm-6 col-6 form-group">
          <label for="profileNpi" class="profile__label">NPI</label>
          <input :disabled=disabled type="text" class="form-control" id="profileNpi" :value="patient.npi">
        </div>
      </div>
      <div class="btn-container">
        <!--<button type="button" class="btn btn-danger5"><font-awesome-icon icon="times" /> CANCEL</button> -->
        <button class="btn btn-primary float-end profile edit" type="button" @click="handleContactEdit('profile', 'profile')"><font-awesome-icon icon="pen" /> EDIT </button>
        <button class="btn btn-primary float-end profile cancel" type="reset" @click="handlePersonalCancel('profile')"><font-awesome-icon icon="ban" /> CANCEL </button>
        <button class="btn btn-primary float-end profile submit" type="submit"><font-awesome-icon icon="check" /> SUBMIT </button>
      </div>

      <h1 class="profile__header">EXTERNAL INFORMATION</h1>
      <div class="row">
        <div class="col-md-3 col-lg-3 col-sm-6 col-6 form-group">
          <label for="profileId" class="profile__label">ID NUMBER</label>
          <input :disabled=disabled type="text" class="form-control profile_input" id="profileId" name="externid" :value="patient.externId">
        </div>
        <div class="form-group">
          <label for="profileUsername" class="profile__label">USERNAME</label>
          <input :disabled=disabled type="text" class="form-control" id="profileUsername" :value="credential.userName">
        </div>
      </div>

    <!-- contact -->
      <h1 class="profile__header">CONTACT INFORMATION</h1>
      <div class="row">
        <div class="col-md-8 col-lg-8 col-12 form-group">
          <label for="profilePhone" class="profile__label">PRIMARY PHONE</label>
          <input :disabled=disabled type="text" class="form-control profile_input" id="profilePhone" name="phone1" :value="patient.phone1">
        </div>
        <div class="col-md-4 col-lg-4 col-12 form-group">
          <label for="profilePhoneType" class="profile__label">PHONE TYPE</label>
          <select :disabled=disabled class="form-select profile_input" id="profilePhoneType" name="phone1Type">
            <option>Please select one of the following</option>
            <option v-for="phone in phoneTypes" :key="phone.id" :selected="patient.phone1type == phone.id">
              {{ phone.type }}
            </option>
          </select>
        </div>
        <div class="col-md-8 col-lg-8 col-12 form-group">
          <label class="profile__label">SECONDARY PHONE</label>
          <input :disabled=disabled type="text" class="form-control profile_input" id="profilePhone2" name="phone2" :value="patient.phone2">
        </div>
        <div class="col-md-4 col-lg-4 col-12 form-group">
          <label class="profile__label">PHONE TYPE</label>
          <select :disabled=disabled class="form-select profile_input" id="profilePhoneType2" name="phone2Type">
            <option>Please select one of the following</option>
            <option v-for="phone in phoneTypes" :key="phone.id" :selected="patient.phone2type == phone.id" >
              {{ phone.type }}
            </option>
          </select>
        </div>
        <div class="col-md-12 col-lg-12 col-12 form-group">
          <label class="profile__label">EMAIL ADDRESS</label>
          <input :disabled=disabled id="profileEmail" type="text" class="form-control profile_input" name="email" :value="patient.email">
        </div>
      </div>
      <div class="btn-container">
        <!--<button type="button" class="btn btn-danger5"><font-awesome-icon icon="times" /> CANCEL</button> -->
        <button class="btn btn-primary float-end profile edit" type="button" @click="handleContactEdit('profile', 'profile')"><font-awesome-icon icon="pen" /> EDIT </button>
        <button class="btn btn-primary float-end profile cancel" type="reset" @click="handlePersonalCancel('profile')"><font-awesome-icon icon="ban" /> CANCEL </button>
        <button class="btn btn-primary float-end profile submit" type="submit"><font-awesome-icon icon="check" /> SUBMIT </button>
      </div>

      <!-- primary address -->
      <h1 class="profile__header">PRIMARY ADDRESS</h1>
      <div class="row">
        <div class="col-md-12 col-lg-12 col-12 form-group">
          <label class="profile__label">ADDRESS 1</label>
          <input :disabled=disabled type="text" class="form-control profile_input" id="profilepaddress1" name="paddress1" :value="patient.address">
        </div>
        <div class="col-md-12 col-lg-12 col-12 form-group">
          <label class="profile__label">ADDRESS 2</label>
          <input :disabled=disabled type="text" class="form-control profile_input" id="profilepaddress2" name="paddress2" :value="patient.addr2">
        </div>
        <div class="col-md-6 col-lg-6 col-12 form-group">
          <label class="profile__label">CITY</label>
          <input :disabled=disabled type="text" class="form-control profile_input" id="profilepaddressCity" name="paddressCity" :value="patient.city">
        </div>
        <div class="col-md-3 col-lg-3 col-12 form-group">
          <label class="profile__label">STATE</label>
          <select :disabled=disabled class="form-select profile_input" id="profilepaddressState" name="paddressState">
            <option>Please select one of the following</option>
            <option v-for="state in states" :key="state.name" :selected="state.id == patient.state">
              {{ state.name }}
            </option>
            <!-- todo pre-select a state -->
          </select>
        </div>
        <div class="col-md-3 col-lg-3 col-12 form-group">
          <label class="profile__label">ZIP</label>
          <input :disabled=disabled type="text" class="form-control profile_input" :value="patient.zip" id="profilepaddressZip" name="paddressZip">
        </div>
      </div>
      <div class="btn-container">
        <!--<button type="button" class="btn btn-danger5"><font-awesome-icon icon="times" /> CANCEL</button> -->
        <button class="btn btn-primary float-end profile edit" type="button" @click="handleContactEdit('profile', 'profile')"><font-awesome-icon icon="pen" /> EDIT </button>
        <button class="btn btn-primary float-end profile cancel" type="reset" @click="handlePersonalCancel('profile')"><font-awesome-icon icon="ban" /> CANCEL </button>
        <button class="btn btn-primary float-end profile submit" type="submit"><font-awesome-icon icon="check" /> SUBMIT </button>
      </div>

    <!-- mailing address -->
      <div class="form-check">
        <input :disabled=disabled class="form-check-input profile_input" type="checkbox" @click="handleMailingCheckbox">
        <label class="form-check-label profile__checkbox">
          My mailing address is the same as my primary address.
        </label>
      </div>

      <h1 class="profile__header">MAILING ADDRESS</h1>
      <div class="row">
        <div class="col-md-12 col-lg-12 col-12 form-group">
          <label class="profile__label">ADDRESS 1</label>
          <input :disabled=disabled type="text" class="form-control profile_input" id="profilemaddress1" name="maddress1" :value="patient.maddr">
        </div>
        <div class="col-md-12 col-lg-12 col-12 form-group">
          <label class="profile__label">ADDRESS 2</label>
          <input :disabled=disabled type="text" class="form-control profile_input" id="profilemaddress2" name="maddress2" :value="patient.maddr2">
        </div>
        <div class="col-md-6 col-lg-6 col-12 form-group">
          <label class="profile__label">CITY</label>
          <input :disabled=disabled type="text" class="form-control profile_input" id="profilemaddressCity" name="maddressCity" :value="patient.mcity">
        </div>
        <div class="col-md-3 col-lg-3 col-12 form-group">
          <label class="profile__label">STATE</label>
          <select :disabled=disabled class="form-select profile_input" id="profilemaddressState" name="maddressState">
            <option>Please select one of the following</option>
            <option v-for="state in states" :key="state.name" :selected="state.id == patient.mstate">
              {{ state.name }}
            </option>
          </select>
        </div>
        <div class="col-md-3 col-lg-3 col-12 form-group">
          <label class="profile__label">ZIP</label>
          <input :disabled=disabled type="text" class="form-control profile_input" id="profilemaddressZip" name="maddressZip" :value="patient.mzip">
        </div>
      </div>
      <div class="btn-container">
        <!--<button type="button" class="btn btn-danger5"><font-awesome-icon icon="times" /> CANCEL</button> -->
        <button class="btn btn-primary float-end profile edit" type="button" @click="handleContactEdit('profile', 'profile')"><font-awesome-icon icon="pen" /> EDIT </button>
        <button class="btn btn-primary float-end profile cancel" type="reset" @click="handlePersonalCancel('profile')"><font-awesome-icon icon="ban" /> CANCEL </button>
        <button class="btn btn-primary float-end profile submit" type="submit"><font-awesome-icon icon="check" /> SUBMIT </button>
      </div>
      </form>
      </div>
  </div>
</template>

<script>
  import { updateProfile } from "@/api/userApi";
  // import { getStates, getPhoneTypes } from '@/data/getters.js';
  export default {
    name: "user-profile",
    props : ['restricted'],
    data () {
      return {
        savedEmail: {},
        allData: this.$store.getters['login/getAllData'],
        immutables: ['Emergency', 'Healthcare Proxy 1', 'Healthcare Proxy 2', 'Attorney', 'maddress', 'paddress', 'personal', 'profile'],
        licensedRel: ['Licensed Practical Nurse', 'Registered Nurse', 'Geriatric Care Manager', 'Physical Therapist', 'Occupational Therapist', 'Dietician', 'Social Worker', 'Speech Therapist'],
      }
    },
    computed: {
      disabled: function() {
        return this.restricted === true;
      },
      suffixes: function () {
        return this.allData.suffixes;
      },
      genders: function () {
        return this.allData.genders;
      },
      credential: function () {
        return this.allData.user;
      },
      patient: function () {
        return this.allData.patient;
      },
      states: function() {
        return this.allData.states
      },
      phoneTypes: function() {
        return this.allData.phoneTypes
      },
      relationships: function() {
        return this.allData.relationDescriptions
      }
    },
    created() {
      console.log(JSON.parse(JSON.stringify(this.allData)))
    },
    methods: {
      // isLicensed(ind) {
      //   let title = document.getElementById('title'+ind).value
      //   if (this.licensedRel.indexOf(title) == -1)
      //     return false
      //   return true
      // },
      handleContactEdit(sectionName, section) {
        let inputs = document.getElementsByClassName(section + "_input")
        Array.prototype.forEach.call(inputs, function(input) {
          input.disabled = false
        })
        document.getElementsByClassName(section + " edit")[0].style.visibility = 'hidden'
        document.getElementsByClassName(section + " cancel")[0].style.visibility = 'visible'
        document.getElementsByClassName(section + " submit")[0].style.visibility = 'visible'
        if (this.immutables.indexOf(sectionName) == -1)
          document.getElementsByClassName(section + " delete")[0].style.visibility = 'visible'
        if (sectionName == 'profile'){
          for (let i = 1; i < 4; i++){
            document.getElementsByClassName(section + " edit")[i].style.visibility = 'hidden'
            document.getElementsByClassName(section + " cancel")[i].style.visibility = 'visible'
            document.getElementsByClassName(section + " submit")[i].style.visibility = 'visible'
          }
        }
      },
      handleMailingCheckbox(){
        let addy1 = document.getElementById('profilepaddress1').value
        let addy2 = document.getElementById('profilepaddress2').value
        let city = document.getElementById('profilepaddressCity').value
        let state = document.getElementById('profilepaddressState').value
        let zip = document.getElementById('profilepaddressZip').value

        document.getElementById('profilemaddress1').value = addy1
        document.getElementById('profilemaddress2').value = addy2
        document.getElementById('profilemaddressCity').value = city
        document.getElementById('profilemaddressZip').value = zip
        document.getElementById('profilemaddressState').options[((this.states.find(st => st.name == state)) || {value: 0}).value].setAttribute('selected', 'selected')
      },
      handlePersonalCancel(section) {
        let inputs = document.getElementsByClassName(section + "_input")
        Array.prototype.forEach.call(inputs, function(input) {
          input.disabled = true
        })
        for (let i = 0; i < 4; i++){
          document.getElementsByClassName(section + " edit")[i].style.visibility = 'visible'
          document.getElementsByClassName(section + " cancel")[i].style.visibility = 'hidden'
          document.getElementsByClassName(section + " submit")[i].style.visibility = 'hidden'
        }

        document.getElementById(section+'Username').setAttribute('value', this.credential.userName == null ? "" : this.credential.userName)
        document.getElementById(section+'Id').setAttribute('value', this.patient.externId == null ? "" : this.patient.externId)
        document.getElementById(section+'Npi').setAttribute('value', this.patient.npi == null ? "" : this.patient.npi)
        document.getElementById(section+'FirstName').setAttribute('value', this.patient.firstName == null ? "" : this.patient.firstName)
        document.getElementById(section+'MiddleName').setAttribute('value', this.patient.middleName == null ? "" : this.patient.middleName)
        document.getElementById(section+'LastName').setAttribute('value', this.patient.lastName == null ? "" : this.patient.lastName)
        document.getElementById(section+'Suffix').options[(this.patient.suffix || 0)].setAttribute('selected', 'selected')
        document.getElementById(section+'DOB').setAttribute('value', this.patient.dob == null ? "" : this.patient.dob)
        document.getElementById(section+'Gender').options[(this.genders.find(gender => gender.value == this.patient.gender[0]) || {id: 1}).id - 1].setAttribute('selected', 'selected')
        document.getElementById(section+'Phone').setAttribute('value', this.patient.phone1 == null ? "" : this.patient.phone1)
        document.getElementById(section+'PhoneType').options[this.patient.phone1type || 0].setAttribute('selected', 'selected')
        document.getElementById(section+'Phone2').setAttribute('value', this.patient.phone2 == null ? "" : this.patient.phone2)
        document.getElementById(section+'PhoneType2').options[this.patient.phone2type || 0].setAttribute('selected', 'selected')
        document.getElementById(section+'Email').setAttribute('value', this.patient.email == null ? "" : this.patient.email)
        document.getElementById(section+'paddress1').setAttribute('value', this.patient.address == null ? "" : this.patient.address)
        document.getElementById(section+'paddress2').setAttribute('value', this.patient.addr2 == null ? "" : this.patient.addr2)
        document.getElementById(section+'paddressCity').setAttribute('value', this.patient.city == null ? "" : this.patient.city)
        document.getElementById(section+'paddressState').options[this.patient.state || 0].setAttribute('selected', 'selected')
        document.getElementById(section+'paddressZip').setAttribute('value', this.patient.zip == null ? "" : this.patient.zip)
        document.getElementById(section+'maddress1').setAttribute('value', this.patient.maddr == null ? "" : this.patient.maddr)
        document.getElementById(section+'maddress2').setAttribute('value', this.patient.maddr2 == null ? "" : this.patient.maddr2)
        document.getElementById(section+'maddressCity').setAttribute('value', this.patient.mcity == null ? "" : this.patient.mcity)
        document.getElementById(section+'maddressState').options[this.patient.mstate || 0].setAttribute('selected', 'selected')
        document.getElementById(section+'maddressZip').setAttribute('value', this.patient.mzip == null ? "" : this.patient.mzip)
      },
      handleSubmit(uid, section) {
        let formData = new FormData(document.getElementById('form_bio'))
        let profile = {
          id: uid,
          firstName: formData.get('firstName'),
          middleName: formData.get('middleName'),
          lastName: formData.get('lastName'),
          suffix : (this.suffixes.find(suffix => suffix.value == formData.get('suffix')) || {id: 0}).id,
          dob: formData.get('dob'),
          gender : (this.genders.find(gender => gender.value == formData.get('gender')) || {id: 0}).id,
          phone1 : formData.get('phone1'),
          phone1type: (this.phoneTypes.find(phone => phone.type == formData.get('phone1Type')) || {id: 0}).id,
          phone2 : formData.get('phone2'),
          phone2type: (this.phoneTypes.find(phone => phone.type == formData.get('phone2Type')) || {id: 0}).id,
          email: formData.get('email'),
          address : formData.get('paddress1'),
          addr2: formData.get('paddress2'),
          city : formData.get('paddressCity'),
          state : (this.states.find(state => state.name == formData.get('paddressState')) || {id: 0}).id,
          zip : formData.get('paddressZip'),
          maddr: formData.get('maddress1'),
          maddr2: formData.get('maddress2'),
          mcity: formData.get('maddressCity'),
          mstate : (this.states.find(state => state.name == formData.get('maddressState')) || {id: 0}).id,
          mzip: formData.get('maddressZip')
        }
        updateProfile(profile).then((a) => {
            console.log(a)
            console.log(JSON.stringify(a))
            if (!alert("Profile updated.")) {
              window.location.reload()
            }
          })
          .catch((b) => {
            alert("Error: Please contact website administration")
            console.dir(b)
          })
      },

    }
  }
</script>

<style scoped lang="scss">
  $color-base: #0060ff;

  .page {
    background-color: #fff;
    margin: 1.5rem auto;
    padding: 2.0rem;
    margin-bottom: 100px;
  }
  .profile__header {
    font-size: 1.5rem;
    color: $color-base;
    text-align: center;
    margin-top: 1.5rem;
    margin-bottom: 1em;
  }
  .profile__label {
    font-size: 0.80rem;
    color: $color-base;
  }
  .profile__checkbox {
    font-size: 0.80rem;
    color: lighten(#000, 30%);
  }
  input, select {
    font-size: 0.8rem;
  }
  .btn-container {
    margin-top: 1.0rem;
    .btn {
      font-size: 0.8rem;
      margin: 2px;
    }
    padding-bottom: 3rem;
  }
  .new-cancel {
    background-color: red;
    border-color: red;
  }
  .cancel {
    visibility: hidden;
    background-color: red;
    border-color: red;
  }
  .submit {
    visibility: hidden;
  }
  .delete {
    visibility: hidden;
  }
  .favorite {
    color: red;
  }
  .unfavorite {
    color: $color-base;
  }
  .licenseInfo {
    display: flex;
    justify-content: center;
  }
  button[name="query_btn"]:enabled {
    background-color: $color-base;
    color: white;
  }


</style>
